export default __webpack_public_path__ + "static/media/dego-screenshot-01.6028537c.png";